import React from "react";
import PropTypes from "prop-types";
import { withUser, meetsLevel } from "@/helpers/user";
import { API_URL } from "@/config";

// Anonymous visitors get plaintext so crawlers don't burst the document API.
const ReexamDocLink = ({ user, text, applicationNumber, docId }) =>
  meetsLevel(user.accessLevel.app, "guest") ? (
    <a
      target="_blank"
      rel="noopener noreferrer nofollow"
      href={`${API_URL}/reexam/${encodeURIComponent(applicationNumber)}/${encodeURIComponent(docId)}`}
    >
      {text}
    </a>
  ) : (
    <span>{text}</span>
  );

ReexamDocLink.propTypes = {
  text: PropTypes.node,
  applicationNumber: PropTypes.string,
  docId: PropTypes.string
};

export default withUser(ReexamDocLink);
